<template>
    <div class="c-wallet">
        <Card v-for="card in cards" :card="card" :noedit="true" />
    </div>
</template>

<script>

import Card from '../Card'
import WebSoc from '@/utils/WebSoc.js'

export default {
    props: ['btn'],
    components: {
        Card
    },
    watch: {
        'btn.wallet_id' ( wallet_id ) { 
            this.getWallet(wallet_id);
        },
        'btn.width' ( width ) {
            this.setScale(width);
        }
    },
    data () {
        return {
            cards: []
        }
    },
    mounted () {
        this.getWallet(this.btn.wallet_id);
        this.setScale(this.btn.width);
    },
    methods: {
        getWallet ( _id ) { 
            if ( !_id ) return;
            WebSoc.SEND('get',{ DB: 'wallets', _id },wallet => {
                if ( wallet.cards.length == 0 ) return console.log('NO CARDS')
                WebSoc.SEND('search',{ DB: 'cards', find: { $or: wallet.cards }},cards => {
                    this.cards = cards;
                })
            })
        },
        setScale ( width ) {
            var scale = 1 / ( 414 / ( width - 30 ) ) ;
            this.$el.style.transform = 'scale('+scale+')'; 
            this.$el.style.backgroundColor = 'rgba(0,0,0,0)'
        }
    }
}

</script>

<style lang="scss">
.c-wallet {
    transform-origin: 0px 0px;
    transform: scale(0.9);
}    
</style>

